'use client';
import { useTranslations } from 'next-intl';
import { MyEquipmentErrorBanner } from 'components/pcc-components';

export default function PageError() {
  const t = useTranslations();
  return (
    <div className="d-block vh-100">
      <MyEquipmentErrorBanner content={t('UNKONWN_ERROR')} />
    </div>
  );
}
